import http from '../../services/http';
import forResponse from '../../utils/forResponse';
import { ANCHOR_LIST, ANCHOR_BROADCAST_STATUS, FANZONES } from '../../constants/apiUrls/apiUrls';


export const getAnchors = () => forResponse(http.get(ANCHOR_LIST));

export const checkAnchorsBroadcastStatus = () => forResponse(http.get(ANCHOR_BROADCAST_STATUS));

export const checkFanZoneStatus = () => forResponse(http.get(FANZONES));
